// extracted by mini-css-extract-plugin
module.exports = {"cancelled_reservation":"cancelled_reservation___-YN02ac9jx_5BrneIzNkvq","cancelled_reservation__hero":"cancelled_reservation__hero___--DzI_WwsDuf_aqayw42M3"};